import { filter, map, Observable, repeat, switchMap, take, takeWhile } from 'rxjs';
import {
  C_Ai_Assistant_Query_Status,
  GetWa_ReplyFromAiAssistantQuery,
  GetWa_ReplyFromAiAssistantQueryVariables,
  SendWa_QueryToAiAssistantMutation,
  SendWa_QueryToAiAssistantMutationVariables,
} from '../../../../graphql/generatedModel';
import { gqlClient } from '../../../../graphql/graphqlRequest';
import { Pub, Service, Sub } from '../../../services/service.abstract';
import { aiAssistantPrompt, aiAssistantResponse } from './gql/aiAssistant.gql';

type Actions = 'prompt' | 'clear';

class PubImpl extends Pub<Actions> {
  prompt(prompt: string): void {
    this.emit('prompt', prompt);
  }
  clear(): void {
    this.emit('clear', {});
  }
}
class SubImpl extends Sub<Actions> {
  prompt(): Observable<AIAssistanRes> {
    return this.actionListener('prompt').pipe(
      switchMap(({ params }) => {
        const variables: SendWa_QueryToAiAssistantMutationVariables = {
          query: params,
          appTimezoneOffset: new Date().getTimezoneOffset().toString(),
        };
        return gqlClient(aiAssistantPrompt, variables);
      }),
      switchMap((value: SendWa_QueryToAiAssistantMutation) => {
        const jobId = value.wawiAssist?.sendWA_QueryToAIAssistant as string;
        const variables: GetWa_ReplyFromAiAssistantQueryVariables = {
          jobId,
        };
        return gqlClient(aiAssistantResponse, variables).pipe(
          map((value: GetWa_ReplyFromAiAssistantQuery) => {
            return value.wawiAssist?.getWA_ReplyFromAIAssistant;
          }),
          repeat<any>({ delay: 1000 }),
          takeWhile(
            ({
              status,
            }: NonNullable<
              GetWa_ReplyFromAiAssistantQuery['wawiAssist']
            >['getWA_ReplyFromAIAssistant']) => {
              return status === C_Ai_Assistant_Query_Status.AQS_LOADING;
            },
            true,
          ),
          filter(
            ({ status }) =>
              status === C_Ai_Assistant_Query_Status.AQS_SUCCESS ||
              status === C_Ai_Assistant_Query_Status.AQS_ERROR,
          ),
          take(1),
          map((value: AIAssistanRes) => {
            return value;
          }),
        );
      }),
    );
  }
}

class AIAssistantService extends Service<Actions> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const aiAssistantService = new AIAssistantService();

export type AIAssistanRes = NonNullable<
  GetWa_ReplyFromAiAssistantQuery['wawiAssist']
>['getWA_ReplyFromAIAssistant'];
